import React, { Fragment, useEffect } from "react";
import { agencyDashboard, clientDashboard } from "../common/allLinks";
import LinkCommonComponent from "../common/LinkCommonComponent";

const dummyData = [1, 2, 3, 4];

export default function WelcomeScreenFirstTime() {
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      localStorage.removeItem("typeOfCompany");
    };
  }, []);

  return (
    <div className="mt-auth-platform-bg text-center">
      <div className="welcome-screen-first-time-main-div text-center">
        <img
          src={"/img/desktop/logo/myrl-square-logo.png"}
          alt="myrl"
          className="welcome-screen-first-time-myrl-logo"
        />
        <h2 className="font-48-nunito-semibold purple-green-gradient-text purple-green-gradient-text--welcome-screen-first-time">
          Welcome to Myrl Tech
        </h2>
        <p className="font-24-nunito-semibold font-24-nunito-semibold--selcome-screen-first-time">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
        <p className="font-36-nunito-semibold pt-35">How it works?</p>
        <div className="welcome-screen-first-time-card-div">
          {dummyData.map((data, index) => (
            <Fragment key={index}>
              <div className="welcome-screen-first-time-card">
                <div className="welcome-screen-first-time-card--img-div"></div>
                <div className="welcome-screen-first-time-card--text-div">
                  <h3 className="welcome-screen-first-time-card--text-1">
                    {data}
                  </h3>
                  <p className="welcome-screen-first-time-card--text-2 font-24-nunito-semibold">
                    Lorem ipsum dolor sit amet, consectetur adipisc
                  </p>
                </div>
              </div>
            </Fragment>
          ))}
        </div>
        <LinkCommonComponent
          linkText="Continue to Dashboard"
          linkPath={
            localStorage.getItem("typeOfCompany") === "0"
              ? clientDashboard
              : agencyDashboard
          }
        />
      </div>
    </div>
  );
}
